import { getExperimentVersion } from './getExperimentVersion';

const RESERVED_PARAMS = ['experiment_version', 'exp_version'];

const forwardQueryParams = (parsedUrl: URL) => {
  const incomingParams = new URLSearchParams(window.location.search);
  incomingParams.forEach((value, key) => {
    if (!RESERVED_PARAMS.includes(key) && !parsedUrl.searchParams.has(key)) {
      parsedUrl.searchParams.set(key, value);
    }
  });
};

const addExperimentVersionToUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    forwardQueryParams(parsedUrl);
    parsedUrl.searchParams.set('experiment_version', getExperimentVersion());
    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return url;
  }
};

export const addLPPlusToUrl = (url: string, app: boolean) => {
  try {
    const parsedUrl = new URL(url);
    const fromUri = new URL(app ? '/plus/payment?app=true' : '/plus/payment', parsedUrl.origin);
    forwardQueryParams(fromUri);
    parsedUrl.searchParams.set('from_uri', `${fromUri.pathname}${fromUri.search}`);
    parsedUrl.searchParams.set('plus', 'true');
    if (app) {
      parsedUrl.searchParams.set('app', 'true');
    }
    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return url;
  }
};

export default addExperimentVersionToUrl;
